import { createSlice } from '@reduxjs/toolkit';
import { AdminDashboardState } from './adminDashboardTypes';
import {
  fetchDashboardStats,
  fetchEmployeeDetails,
  fetchEmployeesWithBirthdayToday,
  fetchEmployeeStats,  // Import the new action
  fetchEmployeeLeaveToday
} from './adminDashboardActions';

const initialState: AdminDashboardState = {
  stats: null,
  employees: [],
  birthdayEmployees: [],
  employeeStats: null,  // New state to store employee stats
  statsLoading: false,
  statsError: undefined,
  employeesLoading: false,
  employeesError: undefined,
  birthdayLoading: false,
  birthdayError: undefined,
  employeeStatsLoading: false,  // New loading state for employee stats
  employeeStatsError: undefined,
  leavetoday : [],
  leaveLoading : false,
  leaveError : undefined,
};

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Dashboard Stats
      .addCase(fetchDashboardStats.pending, (state) => {
        state.statsLoading = true;
        state.statsError = undefined;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload.data;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.statsLoading = false;
        state.statsError = action.payload as string;
      })

      // Fetch Employee Details
      .addCase(fetchEmployeeDetails.pending, (state) => {
        state.employeesLoading = true;
        state.employeesError = undefined;
      })
      .addCase(fetchEmployeeDetails.fulfilled, (state, action) => {
        state.employeesLoading = false;
        state.employees = action.payload.data;
      })
      .addCase(fetchEmployeeDetails.rejected, (state, action) => {
        state.employeesLoading = false;
        state.employeesError = action.payload as string;
      })

      // Fetch Employees with Birthday Today
      .addCase(fetchEmployeesWithBirthdayToday.pending, (state) => {
        state.birthdayLoading = true;
        state.birthdayError = undefined;
      })
      .addCase(fetchEmployeesWithBirthdayToday.fulfilled, (state, action) => {
        state.birthdayLoading = false;
        state.birthdayEmployees = action.payload.data;
      })
      .addCase(fetchEmployeesWithBirthdayToday.rejected, (state, action) => {
        state.birthdayLoading = false;
        state.birthdayError = action.payload as string;
      })

      // Fetch Employee Stats by Employee ID
      .addCase(fetchEmployeeStats.pending, (state) => {
        state.employeeStatsLoading = true;
        state.employeeStatsError = undefined;
      })
      .addCase(fetchEmployeeStats.fulfilled, (state, action) => {
        state.employeeStatsLoading = false;
        state.employeeStats = action.payload.data;
      })
      .addCase(fetchEmployeeStats.rejected, (state, action) => {
        state.employeeStatsLoading = false;
        state.employeeStatsError = action.payload as string;
      })

      //get today Employee leave -Aman sharma
      .addCase(fetchEmployeeLeaveToday.pending, (state) => {
        state.leaveLoading = true;
        state.leaveError = undefined;
      })
      .addCase(fetchEmployeeLeaveToday.fulfilled, (state, action) => {
        state.leaveLoading = false;
        state.leavetoday = action.payload.data;
      })
      .addCase(fetchEmployeeLeaveToday.rejected, (state, action) => {
        state.leaveLoading = false;
        state.leaveError = action.payload as string;
      });
  },
});

export default adminDashboardSlice.reducer;
